import React from "react";
import UpgradeIconSmall from "../../assets/images/zap-icon.svg";
import "../../assets/scss/global.scss";
import ReadMore from "./read-more";
import { Info } from "react-feather";
import ReactTooltip from "react-tooltip";
import HSCodeText from "../country-components/hs-code-text";
import { hsCodeTypeDictionary } from "../../../src/core/global/global-country-dictionary";
import { hsCodeFormatter } from "../../core/global/global-country-functions";

export default class ConditionalComponent extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    dependentField: "",
    mappingField: "",
    infoText: "",
    isHSCodeFormatter: false,
    label: "",
    isReadMore: false,
    readMoreLength: 0,
    isThunderIcon: false,
  };
  componentDidMount() {
    const conditionalComponentData = this.props.configData.conditionalComponentData;
    for (let i = 0; i < conditionalComponentData.length; i++) {
      if (!!conditionalComponentData[i] && !!conditionalComponentData[i].dependentField && conditionalComponentData[i].dependentField !== "") {
        if (!!this.props.mainData[conditionalComponentData[i].dependentField] && ((Array.isArray(this.props.mainData[conditionalComponentData[i].dependentField]) && this.props.mainData[conditionalComponentData[i].dependentField].flat(10).length) || (typeof this.props.mainData[conditionalComponentData[i].dependentField] === "string" && this.props.mainData[conditionalComponentData[i].dependentField].length))) {
          this.setState(conditionalComponentData[i]);
          break;
        }
      } else {
        this.setState(conditionalComponentData[i]);
      }
    }
  }
  render() {
    return (
      <div>
        {this.state.isThunderIcon === true ? (
          <>
            <span className="p-0">
              <img src={UpgradeIconSmall} alt="..." className="img-fluid mr-1" />
            </span>
          </>
        ) : (
          <></>
        )}
        <span>{!!this.state && !!this.state.label ? this.state.label : ""}</span>
        {!!this.state && !!this.state.infoText && this.state.infoText !== "" ? (
          <>
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" />
            <Info className="ml-1" size={13} data-tip={!!this && !!this.state && !!this.state.infoText && this.state.infoText !== "" ? this.state.infoText : ""} />
          </>
        ) : (
          <></>
        )}
        <div>
          {this.state && this.state.hideField && this.props.currentUserPlan === "trademo_intel_us_starter__" ? (
            <span data-tip={`To view ${this.state.label ? this.state.label : "field"}, you would need to upgrade to higher plan.`}>
              <span className="blur-effect ml-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span className="ml-1">
                <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
              </span>
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="right" />
            </span>
          ) : !!this.state && !!this.state.isReadMore && this.state.isReadMore === true ? (
            <>{this.state.mappingField.includes("hs_code") === true ? <HSCodeText hsCodeFieldObject={this.props.mainData[this.state.mappingField]} type={hsCodeTypeDictionary.conditionalViewShipment} sliceLength={this.state.readMoreLength} countryName={this.props.countryName} countryType={this.props.countryType} analyticsCountryID={this.props.analyticsCountryID} pathname={this.props.pathname} currentUserPlan={this.props.currentUserPlan} isReadMore={this.state.isReadMore}></HSCodeText> : <ReadMore dataContent={hsCodeFormatter(this.props.mainData[this.state.mappingField])} dataLength={this.state.readMoreLength} />}</>
          ) : (
            "NA"
          )}
        </div>
      </div>
    );
  }
}
